import { ChangeEvent, FC } from 'react'
import TextField from '@mui/material/TextField'

interface TextFilterFieldProps {
  /** Подпись поля */
  label: string
  /** Текущее значение */
  value: string
  /**
   * Обработчик изменения значения.
   * @param value — новое значение поля
   */
  onChange: (value: string) => void
}

/**
 * Текстовое поле фильтра клиентов.
 * @param label — подпись
 * @param value — значение
 * @param onChange — колбэк изменения
 */
const TextFilterField: FC<TextFilterFieldProps> = ({
  label,
  value,
  onChange,
}) => {
  /**
   * Пробрасывает значение из MUI TextField.
   * @param changeEvent — событие изменения input
   */
  const handleChange = (changeEvent: ChangeEvent<HTMLInputElement>): void => {
    onChange(changeEvent?.target?.value ?? '')
  }

  return (
    <TextField
      fullWidth
      size='small'
      label={label}
      value={value}
      onChange={handleChange}
    />
  )
}

export default TextFilterField
